<template>
  <div class="3-6-9">
    <div :class="cssClass">
      <div
        class="ui column"
        :key="playerId"
        v-for="(player, playerId) in players"
        :class="{
          'pulse animated':
            activeQuestion.forAllPlayers || playerId === activePlayer.id
        }"
      >
        <div
          class="ui center aligned padded"
          :class="{
            orange:
              activeQuestion.forAllPlayers || playerId === activePlayer.id,
            attached:
              isHost &&
              (playerId === activePlayer.id || activeQuestion.forAllPlayers),
            segment: true
          }"
        >
          <div
            class="ui huge statistic"
            :class="{
              orange:
                playerId === activePlayer.id && !activeQuestion.forAllPlayers
            }"
          >
            <div class="value">{{ player.score }}</div>
            <div class="label">{{ player.name | smartTruncate }}</div>
          </div>
        </div>
        <div
          class="ui positive huge bottom attached button"
          :data-player-id="playerId"
          @click.stop="answerQuestion({ playerId, correct: true })"
          v-if="isHost && activeQuestion.forAllPlayers"
        >
          <i class="checkmark icon"></i> [ {{ keys[playerId] }} ]
        </div>
        <div
          class="ui two bottom attached buttons"
          v-else-if="isHost && playerId === activePlayer.id"
        >
          <div
            class="ui negative huge button"
            @click.stop="answerQuestion({ playerId, correct: false })"
            id="wrong-answer"
          >
            <i class="remove icon"></i>
          </div>
          <div
            class="ui positive huge button"
            @click.stop="answerQuestion({ playerId, correct: true })"
            id="correct-answer"
          >
            <i class="checkmark icon"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="ui center aligned fluid container">
      <h1 class="ui center aligned header" v-if="isHost">
        {{ questionNr }}. {{ activeQuestion.question }}
      </h1>
      <h1 class="ui center aligned orange header" v-if="isHost">
        <i class="arrow right icon"></i> {{ activeQuestion.answer }}
      </h1>
    </div>
    <div class="ui center aligned fluid container">
      <div class="ui relaxed horizontal list">
        <div class="item" v-for="(question, index) in questions" :key="index">
          <h1
            class="ui header"
            :class="{
              orange: index + 1 == questionNr,
              emphasized: (index + 1) % 3 == 0
            }"
          >
            {{ index + 1 }}
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { nrToWord } from '@/filters';
import Mousetrap from 'mousetrap';
import { KEYBOARD_KEYS } from '@/config';
import sounds from '@/sounds';

export default {
  name: 'drie-zes-negen',
  data() {
    return { keys: KEYBOARD_KEYS };
  },
  computed: {
    ...mapGetters(['players', 'nrOfPlayers', 'activePlayer', 'isHost']),
    ...mapGetters('drieZesNegen', [
      'questions',
      'activeQuestion',
      'questionNr'
    ]),
    cssClass() {
      return `ui ${nrToWord(this.nrOfPlayers)} column stretched stackable grid`;
    }
  },
  created() {
    this.addKeyboardShortcuts();
  },
  methods: {
    answerQuestion(answer) {
      this.$store.dispatch('drieZesNegen/answerQuestion', answer);
      this.$store.dispatch('syncGame');
      if (this.isHost) {
        sounds.emitSound(answer ? sounds.AUDIO.CORRECT : sounds.AUDIO.WRONG);
      }
    },
    addKeyboardShortcuts() {
      // Blindly click the buttons...
      Mousetrap.bind('left', () => {
        const wrongButton = document.querySelector('#wrong-answer');
        if (wrongButton) wrongButton.click();
        return false;
      });
      Mousetrap.bind('right', () => {
        const correctButton = document.querySelector('#correct-answer');
        if (correctButton) correctButton.click();
        return false;
      });
      Mousetrap.bind(this.keys, e => {
        const index = this.keys.indexOf(e.key);
        // -> add qwerty & numeric support
        const playerId =
          index > 9 ? index - Math.floor(index / 10) * 10 : index;
        const playerButton = document.querySelector(
          `[data-player-id='${playerId}']`
        );
        if (playerButton) playerButton.click();
        return false;
      });
    }
  }
};
</script>

<style scoped>
.fluid.container {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.ui.list > .item .header {
  font-size: 3rem;
  opacity: 0.45;
}
.ui.list > .item .orange {
  opacity: 1;
}
.ui.list > .item .emphasized {
  font-size: 4rem;
  opacity: 1;
}
</style>
